import moment from "moment/moment";

/**
 * 📅 Convertit filter.singleDay en objet moment correctement
 *
 * ⚠️ IMPORTANT: filter.singleDay est un objet Dayjs, pas un string ou Date native
 *
 * ❌ PROBLÈME: moment(filter.singleDay) corrompt la date
 * ✅ SOLUTION: moment(filter.singleDay.toDate()) préserve la date originale
 *
 * @param {Object} filter - L'objet filtre contenant singleDay (objet Dayjs)
 * @returns {moment.Moment} - Objet moment avec la date correcte
 *
 * Exemple d'usage:
 * ```javascript
 * const filterMoment = getFilterMoment(filter);
 * const weekStart = filterMoment.startOf('isoWeek');
 * const previousWeek = filterMoment.subtract(1, 'week');
 * ```
 */
export function getFilterMoment(filter) {
    if (!filter || !filter.singleDay) {
        return null;
    }
    // Utilise .toDate() pour convertir Dayjs en Date native avant moment()
    return moment(filter.singleDay.toDate());
}

export function getDateString(filter) {
    if (!filter || !filter.singleDay) {
        return "";
    }
    // FIXME: Cette fonction devrait utiliser getFilterMoment pour la cohérence
    // Actuellement elle utilise l'ancien pattern qui peut causer des problèmes
    return moment(filter?.singleDay).format("YYYY-MM-DD")
}